import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { ToastContainer } from './Toast';
import { initAnalytics } from './lib/analytics';

// Init PostHog + Sentry before render (no-op without their env keys).
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
    <ToastContainer />
  </ErrorBoundary>
);
